var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayPanel
    ? _c("CompassPanel", {
        staticClass: "panel-create-phonecall",
        attrs: { value: true, title: _vm.panelTitle, icon: "obj-slsy-phone" },
        on: { beforeClose: _vm.onClosePanel },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function() {
                return [
                  _vm.isLoading
                    ? _c("ActivityDetailPanelContentLoadingState")
                    : [
                        _c(
                          "h3",
                          {
                            staticClass:
                              "panel-create-phonecall__content-title typographies-heading-h3"
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.localizedTexts.contentTitle) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "panel-create-phonecall__form" },
                          [
                            !_vm.isDone
                              ? _c(
                                  "CompassDescriptionList",
                                  { attrs: { type: "alternative" } },
                                  [
                                    _c(
                                      "CompassDescriptionListItem",
                                      {
                                        attrs: {
                                          label: _vm.localizedTexts.priority
                                        }
                                      },
                                      [
                                        _c("ActivitiesPriorityIconButton", {
                                          attrs: {
                                            isActive: _vm.activityIsPrioritized,
                                            enabled: ""
                                          },
                                          on: { clicked: _vm.togglePriority }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isDone
                              ? _c(
                                  "CompassFormItem",
                                  {
                                    attrs: {
                                      label: _vm.localizedTexts.source,
                                      orientation: "horizontal",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _c(
                                      "CompassRadioGroup",
                                      {
                                        attrs: {
                                          label: "",
                                          direction: "horizontal"
                                        },
                                        model: {
                                          value: _vm.activityFormData.source,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.activityFormData,
                                              "source",
                                              $$v
                                            )
                                          },
                                          expression: "activityFormData.source"
                                        }
                                      },
                                      _vm._l(
                                        _vm.metas.phonecall.sources,
                                        function(source) {
                                          return _c("CompassRadio", {
                                            key: source.id,
                                            attrs: {
                                              modelValue: source.id,
                                              label: source.label
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "CompassFormItem",
                              {
                                attrs: {
                                  label: _vm.localizedTexts.label,
                                  orientation: "horizontal",
                                  size: "small"
                                }
                              },
                              [
                                _c(
                                  "CompassSelect",
                                  {
                                    attrs: {
                                      menuClass: "phonecall-form__select-menu"
                                    },
                                    model: {
                                      value: _vm.activityFormData.topic,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.activityFormData,
                                          "topic",
                                          $$v
                                        )
                                      },
                                      expression: "activityFormData.topic"
                                    }
                                  },
                                  _vm._l(_vm.topicsOptions, function(topic) {
                                    return _c("CompassDropdownSelectOption", {
                                      key: topic.id,
                                      attrs: {
                                        label: topic.label,
                                        value: topic.id,
                                        type: "text"
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("ActivityFormPanelDatePhoneCall", {
                              attrs: {
                                activityDate: _vm.activityFormData.date,
                                workingDays: _vm.metas.working_days,
                                workingHours: _vm.metas.working_hours,
                                activityData: _vm.activityData,
                                isDone: _vm.isDone
                              },
                              on: {
                                "update:activityDate": function(value) {
                                  return (_vm.activityFormData.date = value)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "CompassFormItem",
                              {
                                attrs: {
                                  label: _vm.$t.__("common.labels.assignee"),
                                  size: "small",
                                  orientation: "horizontal",
                                  disabled: !_vm.canUpdateAssignee
                                }
                              },
                              [
                                _c(
                                  "CompassSelect",
                                  {
                                    attrs: {
                                      menuClass: "phonecall-form__select-menu",
                                      disabled: !_vm.canUpdateAssignee
                                    },
                                    model: {
                                      value: _vm.activityFormData.owner_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.activityFormData,
                                          "owner_id",
                                          $$v
                                        )
                                      },
                                      expression: "activityFormData.owner_id"
                                    }
                                  },
                                  _vm._l(_vm.staffFiltered, function(staff) {
                                    return _c("CompassDropdownSelectOption", {
                                      key: staff.id,
                                      attrs: {
                                        value: staff.id,
                                        label: _vm.getFullNameUser(staff),
                                        avatar: _vm.formatUserToCompassAvatar(
                                          staff
                                        ),
                                        type: "avatar",
                                        disabled: !_vm.canUpdateAssignee
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.shouldDisplaySelectContact
                              ? _c(
                                  "CompassFormItem",
                                  {
                                    attrs: {
                                      label: _vm.$t.__("common.labels.contact"),
                                      orientation: "horizontal",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _c(
                                      "CompassSelect",
                                      {
                                        attrs: {
                                          menuClass:
                                            "phonecall-form__select-menu",
                                          placeholder: _vm.$t.__(
                                            "common.labels.add_contact"
                                          )
                                        },
                                        model: {
                                          value: _vm.contactId,
                                          callback: function($$v) {
                                            _vm.contactId = $$v
                                          },
                                          expression: "contactId"
                                        }
                                      },
                                      _vm._l(_vm.contactsFetched, function(
                                        contactFetched
                                      ) {
                                        return _c(
                                          "CompassDropdownSelectOption",
                                          {
                                            key: contactFetched.id,
                                            attrs: {
                                              label: _vm.getFullNameUser(
                                                contactFetched
                                              ),
                                              avatar: _vm.formatUserToCompassAvatar(
                                                contactFetched
                                              ),
                                              value: contactFetched.id,
                                              type: "avatar"
                                            }
                                          }
                                        )
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("RichText", {
                              staticClass: "description-input-max-height",
                              attrs: {
                                options: _vm.optionsRichText,
                                formitem: {
                                  size: "small",
                                  label: _vm.$t.__("common.labels.note")
                                }
                              },
                              model: {
                                value: _vm.activityFormData.description,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.activityFormData,
                                    "description",
                                    $$v
                                  )
                                },
                                expression: "activityFormData.description"
                              }
                            }),
                            _vm._v(" "),
                            _vm.isDone
                              ? _c(
                                  "CompassFormItem",
                                  {
                                    attrs: {
                                      label:
                                        _vm.localizedTexts.phonecall.duration,
                                      orientation: "horizontal",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _c("DurationInput", {
                                      attrs: { placeholder: "00:00:00" },
                                      on: {
                                        "update:value": function(value) {
                                          return (_vm.durationInput = value)
                                        }
                                      },
                                      model: {
                                        value: _vm.durationInput,
                                        callback: function($$v) {
                                          _vm.durationInput = $$v
                                        },
                                        expression: "durationInput"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isDone
                              ? _c(
                                  "CompassFormItem",
                                  {
                                    attrs: {
                                      label:
                                        _vm.localizedTexts.phonecall.result,
                                      orientation: "horizontal",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _c(
                                      "CompassSelect",
                                      {
                                        attrs: {
                                          menuClass:
                                            "phonecall-form__select-menu"
                                        },
                                        model: {
                                          value: _vm.activityFormData.result,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.activityFormData,
                                              "result",
                                              $$v
                                            )
                                          },
                                          expression: "activityFormData.result"
                                        }
                                      },
                                      _vm._l(_vm.resultOptions, function(
                                        result
                                      ) {
                                        return _c(
                                          "CompassDropdownSelectOption",
                                          {
                                            key: result.id,
                                            attrs: {
                                              label: result.label,
                                              value: result.id
                                            }
                                          }
                                        )
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isDone
                              ? _c(
                                  "CompassAccordion",
                                  {
                                    staticClass:
                                      "panel-create-phonecall__form-advanced-settings",
                                    attrs: {
                                      title: _vm.$t.__(
                                        "common.labels.advanced_settings"
                                      ),
                                      open: ""
                                    }
                                  },
                                  [
                                    _c("ActivityFormPanelReminder", {
                                      attrs: {
                                        reminders:
                                          _vm.activityFormData.reminders,
                                        isEditMode: !!_vm.activityData
                                      },
                                      on: {
                                        updateActivityReminder: function(
                                          reminders
                                        ) {
                                          return (_vm.activityFormData.reminders = reminders)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                ]
              },
              proxy: true
            },
            {
              key: "footer",
              fn: function() {
                return [
                  !_vm.isLoading
                    ? _c(
                        "div",
                        { staticClass: "panel-create-phonecall__footer" },
                        [
                          _c("CompassButton", {
                            attrs: {
                              label: _vm.localizedTexts.cancelBtn,
                              type: "secondary",
                              disabled: _vm.saveIsPending
                            },
                            on: { click: _vm.onClosePanel }
                          }),
                          _vm._v(" "),
                          _c("CompassButton", {
                            attrs: {
                              label: _vm.localizedTexts.saveBtn,
                              loading: _vm.saveIsPending
                            },
                            on: { click: _vm.onSave }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              },
              proxy: true
            }
          ],
          null,
          false,
          391455406
        )
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }